import { createFeature, createReducer, on } from '@ngrx/store';
import { updateLocalBaseState } from './actions.base';


export interface BaseState {
  systemLookups: any;
  systemSettings: any;
  translation: { [key: string]: string } | null;
  biUrl: string | null;
}

const initialBaseState: BaseState = {
  systemLookups: null,
  systemSettings: null,
  translation: null,
  biUrl: null,
};

export const baseReducer = createFeature(
  {
    name: 'baseReducer',
    reducer: createReducer(
      initialBaseState,
      on(updateLocalBaseState, (state, { key, value }): BaseState => ({
        ...state,
        [key]: value
      })),
    )
  }
);
